import { makeStyles, Typography } from '@material-ui/core';
import React from 'react'
import Container from '@material-ui/core/Container';

const useStyles = makeStyles (() => ({
    typographyStyles: {
        flex: 1
    },
    centerText: {
        textAlign: "center", 
        fontSize: "2em",
        margin: "70px 0 20px 0",
    }
}));

const PageTitle = props => {
    const { title} = props;
    const classes = useStyles ();
    return (
        <Typography className={classes.centerText}>
            {title}
        </Typography>
    );
};

export default PageTitle;

